import React from "react"
import { Link, useParams } from "react-router-dom"
import { BsMeta, BsWhatsapp } from "react-icons/bs"
import { MdOutlineChatBubbleOutline } from "react-icons/md"
import { TbApi, TbForms } from "react-icons/tb"
import { useAuth } from "../../../contexts/authContext"
import ProgressSetup from "./ProgressSetup"
import styles from "./onboarding.module.css"

const ChooseIntegrations = ({ step = 0, totalSteps = 7, nextStep = () => { } }) => {
    const { account_id } = useParams()
    const { account, permissions, verifyIfModuleIsActive } = useAuth()
    const canConfigure = permissions?.integrations >= 1
    const platforms = account?.chat?.platforms || []

    const integrations = [
        {
            name: "Formulários",
            description: "Receba automaticamente os contatos das suas páginas e landing pages.",
            icon: <TbForms />,
            path: `/${account_id}/integrations/forms`,
        },
        {
            name: "Meta Ads",
            description: "Conecte suas páginas e envie os leads das campanhas direto ao funil.",
            icon: <BsMeta />,
            path: `/${account_id}/integrations/meta`,
        },
        {
            name: "API",
            description: "Integre sites e sistemas próprios usando tokens e documentação da API.",
            icon: <TbApi />,
            path: `/${account_id}/integrations/api`,
        },
    ]

    if (verifyIfModuleIsActive("CHAT")) {
        integrations.unshift({
            name: platforms.includes("whatsapp_api") ? "WhatsApp API" : "Canais de atendimento",
            description: "Centralize conversas e distribua os atendimentos entre sua equipe.",
            icon: platforms.some(platform => platform.includes("whatsapp")) ? <BsWhatsapp /> : <MdOutlineChatBubbleOutline />,
            path: platforms.includes("whatsapp_api")
                ? `/${account_id}/integrations/chat/whatsapp-api`
                : (platforms.includes("whatsapp") ? `/${account_id}/integrations/chat/whatsapp` : `/${account_id}/integrations/chat`),
        })
    }

    return (
        <ProgressSetup
            step={step}
            totalSteps={totalSteps}
            title="Conecte seus canais"
            description="Estas são as integrações disponíveis no seu plano. Você pode abrir uma configuração agora ou continuar e fazer isso depois."
            btnText="Continuar"
            btnAltText="Ver todas as integrações"
            onClick={nextStep}
            onClickAlt={() => window.open(`/${account_id}/integrations`, "_blank", "noopener,noreferrer")}
        >
            <div className={styles.cardGrid}>
                {integrations.map(integration => (
                    <article className={styles.card} key={integration.name}>
                        <div className={styles.cardIcon}>{integration.icon}</div>
                        <div>
                            <h2>{integration.name}</h2>
                            <p>{integration.description}</p>
                        </div>
                        {canConfigure
                            ? <Link to={integration.path} target="_blank" rel="noreferrer">Configurar agora</Link>
                            : <span className={styles.permissionHint}>Peça acesso ao administrador</span>
                        }
                    </article>
                ))}
            </div>
        </ProgressSetup>
    )
}

export default ChooseIntegrations
